import { render, staticRenderFns } from "./PassWordChange.vue?vue&type=template&id=5ca85d02"
import script from "./PassWordChange.vue?vue&type=script&lang=js"
export * from "./PassWordChange.vue?vue&type=script&lang=js"
import style0 from "./PassWordChange.vue?vue&type=style&index=0&id=5ca85d02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports